import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { initializeCore } from '@/core';
import App from './App';
import './ui/styles/global.css';

// Registries must be filled before any component reads them — the store
// restores a saved design during module initialisation.
initializeCore();

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root element.');

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
